<template>
  <div class="grades">
    <div
      class="grade"
      v-for="grade in JSON.parse(this.grade_scale)"
      :key="grade"
      :class="{ active: active == grade }"
      @click="onClick(grade)"
    >{{ grade }}</div>
  </div>
</template>

<script>
export default {
  props: ['value', 'grade_scale'],
  data() {
    return {
      active: null,
    }
  },
  methods: {
    onClick(index) {
      this.active = index
      this.$emit('input', this.active)
    }
  },
  watch: {
    value() {
      this.active = this.value
    }
  }
}
</script>

<style scoped lang="scss">
.grades {
  display: flex;
}

.grade {
  font-size: 40px;
  margin: 0 15px;
  color: rgba(250, 250, 250, .3);
  cursor: pointer;

  &.active {
      color: rgba(250, 250, 250, 1);
  }

  .dark & {
    color: rgba(0, 0, 0, .3);
  }
  .dark &.active {
    color: rgba(255, 208, 0, 0.8);
  }

}
</style>
